import React from 'react'
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    IconButton,
    Typography,
    Stack,
    Switch
} from "@material-ui/core"
import CloseIcon from '@material-ui/icons/Close'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    divider: {
        width: 2,
        backgroundColor: theme.palette.primary.main,
        marginLeft: 15,
        marginRight: 15
    },
}))

const handleSave = ( setDialogOpen, updateConsent, analytical ) => {
    updateConsent(analytical)
    setDialogOpen(false)
}

const CookieOptionsDialog = ({ dialogOpen, setDialogOpen, updateConsent }) => {
    const { t } = useTranslation()
    const classes = useStyles()
    const [analytical, setAnalytical] = React.useState(true)

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            onClose={() => setDialogOpen(false)}
            open={dialogOpen}
        >
            <DialogTitle sx={{m: 0, p: 2, fontWeight: "bold", fontSize: "2rem"}}>
                {t("cookieDialog.title")}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setDialogOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers >
                <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom="30px">
                        <Typography width="100px" fontSize="1.2rem">
                            {t("cookieDialog.technical.title")}
                        </Typography>
                        <Divider color="primary" orientation="vertical" flexItem className={classes.divider}/>
                        <Typography width="800px">
                            {t("cookieDialog.technical.description")}
                        </Typography>
                        <Switch disabled defaultChecked/>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom="30px">
                        <Typography width="100px" fontSize="1.2rem">
                            {t("cookieDialog.functional.title")}
                        </Typography>
                        <Divider color="primary" orientation="vertical" flexItem className={classes.divider}/>
                        <Typography width="800px">
                            {t("cookieDialog.functional.description")}
                        </Typography>
                        <Switch disabled defaultChecked />
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom="30px">
                        <Typography width="100px" fontSize="1.2rem">
                            {t("cookieDialog.analytical.title")}
                        </Typography>
                        <Divider color="primary" orientation="vertical" flexItem className={classes.divider}/>
                        <Typography width="800px">
                            {t("cookieDialog.analytical.description")}
                        </Typography>
                        <Switch onChange={(event) => setAnalytical(event.target.checked)}/>
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={() => handleSave(setDialogOpen, updateConsent, analytical)}
                >
                    {t("cookieDialog.save")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { CookieOptionsDialog }
